import { render, staticRenderFns } from "./MakeupCreate.vue?vue&type=template&id=a3018b16"
import script from "./MakeupCreate.vue?vue&type=script&lang=js"
export * from "./MakeupCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports